import { Component, Input, OnInit } from '@angular/core';
import { IDynamicComponentConfig } from '../../dynamic-component';

@Component({
  selector: 'app-limit-display',
  templateUrl: './limit-display.component.html',
  styles: [
    `
      .hasEerror {
        color: red;
      }
    `
  ]
})
export class LimitDisplayComponent implements OnInit {
  constructor() {}

  @Input() config: IDynamicComponentConfig;

  ngOnInit() {}
}
